import React, {Component} from 'react';
import {FormattedMessage} from 'react-intl';
import './SloganSection.css';

class SloganSection extends Component {


    render() {
        return (
            <div className="row fullscreen d-flex align-items-center justify-content-start">
                <div className="banner-content col-lg-8 col-md-12">
                    <h1 className="text-uppercase">
                        <FormattedMessage id='slogan_title'
                                          description='say hello to Howard.'
                                          defaultMessage='{slogan_title_str}'
                                          values={{slogan_title_str: this.props.slogan_title,}}
                        />
                    </h1>
                    <p className="text-white">
                    </p>
                    <a href="#user_cases_sec" className="primary-btn header-btn text-uppercase">

                        <FormattedMessage id='slogan_button_text'
                                          tagName={"i"}
                                          description='say hello to Howard.'
                                          defaultMessage='{button_txt_str}'
                                          values={{button_txt_str: this.props.slogan_button_text,}}
                        />
                    </a>
                </div>
            </div>
        );
    }
}

export default SloganSection;


// WEBPACK FOOTER //
// ./src/components/SloganSection.js